export const constants = {
  MFE_EFFICIENCY_NAME: 'efficiency',
  MFE_EXPOSED_PATH: './EfficiencyApp',
  TREND_GRAPH_EXPOSED_PATH: './TrendGraph',
};
